import type { DrillProgress } from "./xiezi-stages.js";

/**
 * How much of a 汉字 writing drill a reader without an account may do.
 *
 * A visitor does the first stage and the start of the second, then meets a
 * gate asking them to sign up to finish (Hugh, 2026-10-16). The two stages of
 * tracing show what the drill is. The stages written from memory are where
 * the learning happens, and those are worth an account.
 * `.claude/notes/exercises-strategy.md` under "A taste, then five a day" has
 * the reasoning.
 *
 * One rule serves both drills. The drill on a 词典 entry stops at the third
 * pass of the second stage. An Exercise takes its characters in turn, a pass
 * each, so the same rule stops it before the third round of that stage.
 */

/**
 * How many passes of the second stage a visitor does.
 *
 * A starting value, like `charactersPerDrill`.
 */
export const tastePasses = 2;

/**
 * Whether a visitor may write a character from this place.
 * @param progress - Where the reader is with the character.
 * @returns Whether the place is inside the taste.
 */
export function withinTaste(progress: DrillProgress): boolean {
  return (
    progress.stage === 0 ||
    (progress.stage === 1 && progress.pass < tastePasses)
  );
}
